import { useUpdateReturnRequestInCache } from "@babackapp/private-api-client/client/use-invalidate-return-request";
import useUpdateReturnStatus from "@babackapp/private-api-client/client/use-update-return-status";
import type { UpdateReturnRequestStatusDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { List } from "lucide-react";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useViewerHasAtLeastCustomerSupportRights } from "@/lib/rights/use-viewer-has-right";
import { isReturnRequestApproved } from "@/pages/(app)/returns/utils/is-return-request-approved";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";

export function useMarkAsValidatedAction() {
  const { data: shop } = useCurrentShopSuspense();
  const returnRequest = useCurrentReturnRequest();
  const isApprovedAlready = isReturnRequestApproved(returnRequest.status);
  const isCancelled = returnRequest.status.cancelled.done;
  const t = useTranslation();
  const hasCustomerSupportRight = useViewerHasAtLeastCustomerSupportRights();
  const updateReturnRequestInCache = useUpdateReturnRequestInCache();
  const { mutate: updateStatusMutation } = useUpdateReturnStatus({
    onSuccess(returnRequest) {
      updateReturnRequestInCache({ returnRequest });
    },
  });

  function updateStatus(status: UpdateReturnRequestStatusDto["status"]) {
    updateStatusMutation({
      params: {
        path: {
          returnRequestId: returnRequest.id,
          shopId: shop.id,
        },
      },
      body: { status },
    });
  }

  return {
    label: t("returnDetail.validate"),
    icon: <List className="h-5 w-5 text-green-400" />,
    enabled:
      hasCustomerSupportRight &&
      !returnRequest.status.treatedMerchant.done &&
      !isCancelled &&
      isApprovedAlready,
    onClick: () => updateStatus("treatedMerchant"),
  };
}
